import React, { createContext, useState, useContext, useEffect } from "react";
import { useLocalStorage } from "../hooks/useLocalStorage";

const ThemeContext = createContext();
const ThemeUpdateContext = createContext();

export function useTheme() {
	return useContext(ThemeContext);
}

export function useThemeUpdate() {
	return useContext(ThemeUpdateContext);
}

export default function ThemeProvider({ children }) {
	const [theme, setTheme] = useLocalStorage("theme", {});

	const sepiaTheme = {
		light: "sepiaLight",
		dark: "sepiaDark",
		foreground: "sepiaForeground",
		paragraph: "sepiaParagraph",
		secondary: "sepiaSecondary",
		overlay: "sepiaOverlay",
		shadow: "sepiaShadow",
		border: "sepiaBorder",
		link: "sepiaLink",
		borderBottom: "sepiaBorderBottom",
		tagOverlay: "sepiaTagOverlay",
		tagForeground: "sepiaTagForeground"

	};

	const darkTheme = {
		light: "darkLight",
		dark: "darkDark",
		foreground: "darkForeground",
		paragraph: "darkParagraph",
		secondary: "darkSecondary",
		overlay: "darkOverlay",
		shadow: "darkShadow",
		border: "darkBorder",
		link: "darkLink",
		borderBottom: "darkBorderBottom",
		tagOverlay: "darkTagOverlay",
		tagForeground: "darkTagForeground"
	};

	const lightTheme = {
		light: "lightLight",
		dark: "lightDark",
		foreground: "lightForeground",
		paragraph: "lightParagraph",
		secondary: "lightSecondary",
		overlay: "lightOverlay",
		shadow: "lightShadow",
		border: "lightBorder",
		link: "lightLink",
		borderBottom: "lightBorderBottom",
		tagOverlay: "lightTagOverlay",
		tagForeground: "lightTagForeground"

	};

	function toggleTheme(selectedTheme) {
		if (selectedTheme === "light") {
			setTheme(lightTheme);
		}
		if (selectedTheme === "dark") {
			setTheme(darkTheme);
		}
		if (selectedTheme === "sepia") {
			setTheme(sepiaTheme);
		}
	}

	return (
		<ThemeContext.Provider value={theme}>
			<ThemeUpdateContext.Provider value={toggleTheme}>
				{children}
			</ThemeUpdateContext.Provider>
		</ThemeContext.Provider>
	);
}
